<template>
  <div class="bread-crumbs">
    <div
      class="bread-crumbs-item"
      v-for="(route, index) in routes"
      :key="index"
    >
      <span
        :class="index === routes.length - 1 ? 'active' : ''"
        @click="linkTo(route)"
        >{{ route.name }}</span
      >
      <i v-if="index !== routes.length - 1">></i>
    </div>
  </div>
</template>

<script>
import router from "@/router";
export default {
  data() {
    return {};
  },
  props: {
    routes: Array,
  },
  methods: {
    linkTo(route) {
      if (route.href) {
        router.push(route.href);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bread-crumbs {
  height: 22px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  &-item {
    color: #a6a7a7;

    span {
      cursor: pointer;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 22px;

      &:hover {
        text-decoration: underline;
      }

      &.active {
        color: #131415;
				cursor: default;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>
